import { render, staticRenderFns } from "./speakerItem.vue?vue&type=template&id=9b324fcc&scoped=true"
import script from "./speakerItem.vue?vue&type=script&lang=js"
export * from "./speakerItem.vue?vue&type=script&lang=js"
import style0 from "./speakerItem.vue?vue&type=style&index=0&id=9b324fcc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b324fcc",
  null
  
)

export default component.exports